<div> 
  <app-relatorio-vendas-filtro
        [filtros]="filtros">
  </app-relatorio-vendas-filtro>
  <app-relatorio-vendas-lista
        [filtros]="filtros"
        (definirFiltro)="definirFiltro()"
        (exibir)="selecionar($event)">
  </app-relatorio-vendas-lista>
 </div>
 
